module.exports = __webpack_public_path__ + "img/inu_gallery4.062339d1.jpg";